import BaseUpdateRequest from "../Shared/BaseUpdateRequest";
import InterviewCancelledReason from "./InterviewCancelledReason";
import OfferCancelledReason from "./InterviewCancelledReason";

export default class CancelJobWorkerInterviewRequest extends BaseUpdateRequest {
    jobWorkerInterviewId = '';
    cancelReason: InterviewCancelledReason;
 
}